var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-left-chart-1"},[_c('div',{staticClass:"header-name"},[_vm._v("机电设备完好率")]),_vm._m(0),_c('dv-charts',{attrs:{"option":_vm.option}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details-value"},[_c('span',[_vm._v("99.01")]),_vm._v("%")])
}]

export { render, staticRenderFns }